<template>
  <div class="mx-a my-3 container" :class="{ '<md:bg-brand-3': isOpen }">
    <div v-if="isChecksumValid === false" class="container">
      <vf-notification :dismissible="false" type="error">
        {{ $t.productFinder.previousSelectionsInvalidDescription }}
        <base-link class="underlined" :to="finderUrlWithoutStep">
          {{ $t.productFinder.previousSelectionsInvalidLink }}
        </base-link>
      </vf-notification>
    </div>
    <div
      v-else-if="isChecksumValid"
      class="py-3 <md:f-col <md:space-y-2 md:flex md:space-x-3"
      :class="{ 'md:bg-brand-3 md:px-4': isOpen }"
    >
      <div>
        <vf-button :aria-expanded="isOpen" size="tiny" variant="secondary" @click="openClick">
          <vf-icon class="mr-3" dir="left" :name="isOpen ? 'close' : 'arrow'" size="md" />
          {{ isOpen ? $t.close : $t.productFinder.editSelection }}
        </vf-button>
      </div>
      <vf-carousel-elevate
        v-if="isOpen"
        class="min-w-0 flex-1"
        class-container="gap-3"
      >
        <base-link
          v-for="({ id, title, values }) in data"
          :key="id"
          class="w-full flex b b-gray bg-white p3 pt-1"
          style="width: 15rem"
          target="_self"
          :to="getFinderStepUrl(id)"
        >
          <vf-icon
            class="mr-3"
            dir="left"
            name="arrow"
            size="sm"
            style="margin-top: .1rem"
          />
          <div class="w-full">
            <p class="text-sm font-secondary uppercase">
              {{ title }}
            </p>
            <div>
              <p v-for="(value, keyValue) in values" :key="keyValue" class="text-sm">
                {{ value }}
              </p>
            </div>
          </div>
        </base-link>
      </vf-carousel-elevate>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ProductFinderContent } from '#types/components/cms/product-finder'

const { activeToggles, content, contentChecksum, finderUrl } = defineProps<{
  activeToggles: string[]
  content: ProductFinderContent
  contentChecksum?: string
  finderUrl: string
}>()

const isOpen = ref<boolean>(false)
const isChecksumValid = ref<boolean | null>(null)
const data = computed(() =>
  content.steps.flatMap(({ id, title, toggles = [] }) => {
    const values = toggles
      .filter(({ id: toggleId }) => activeToggles.includes(`${id}-${toggleId}`))
      .map(({ title }) => title)
    return values.length ? [{ id, title, values }] : []
  })
)

const openClick = () => isOpen.value = !isOpen.value

const getFinderUrl = (stepId?: string) => {
  const url = new URL(finderUrl, 'https://canvas.local')
  if (stepId) url.searchParams.set('step', stepId)
  else url.searchParams.delete('step')
  return `${url.pathname}${url.search}${url.hash}`
}

const finderUrlWithoutStep = computed(() => getFinderUrl())
const getFinderStepUrl = (stepId: string) => getFinderUrl(stepId)

onMounted(async () => {
  isChecksumValid.value = contentChecksum === await generateStableHashHex(content.steps)
})
</script>
